import { render } from "./MenuProductos.vue?vue&type=template&id=d2e07e32&scoped=true"
import script from "./MenuProductos.vue?vue&type=script&lang=js"
export * from "./MenuProductos.vue?vue&type=script&lang=js"

import "./MenuProductos.vue?vue&type=style&index=0&id=d2e07e32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2e07e32"]])

export default __exports__